import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header", "button", "navLink", "menuButton"]
  static classes = [
    "headerScrolled",
    "headerTransparent",
    "buttonScrolled",
    "buttonTransparent",
    "navLinkScrolled",
    "navLinkTransparent",
    "menuButtonScrolled",
    "menuButtonTransparent",
  ]
  static values = {
    solidNavbar: Boolean,
  }

  declare readonly headerTarget: HTMLElement
  declare readonly buttonTarget: HTMLElement
  declare readonly navLinkTargets: HTMLElement[]
  declare readonly menuButtonTarget: HTMLElement
  declare readonly hasButtonTarget: boolean
  declare readonly hasNavLinkTarget: boolean
  declare readonly hasMenuButtonTarget: boolean
  declare readonly headerScrolledClasses: string[]
  declare readonly headerTransparentClasses: string[]
  declare readonly buttonScrolledClasses: string[]
  declare readonly buttonTransparentClasses: string[]
  declare readonly navLinkScrolledClasses: string[]
  declare readonly navLinkTransparentClasses: string[]
  declare readonly menuButtonScrolledClasses: string[]
  declare readonly menuButtonTransparentClasses: string[]
  declare readonly solidNavbarValue: boolean

  private scrolled = false

  connect() {
    // Skip scroll behavior on pages with solid navbar
    if (this.solidNavbarValue) {
      return
    }

    // Set initial state based on current scroll position
    requestAnimationFrame(() => {
      this.scrolled = window.scrollY > 50
      this.updateStyles()
    })
  }

  scrollHandler() {
    // Skip scroll behavior on pages with solid navbar
    if (this.solidNavbarValue) {
      return
    }

    const scrollPosition = window.scrollY
    const newScrolled = scrollPosition > 50

    if (newScrolled !== this.scrolled) {
      this.scrolled = newScrolled
      this.updateStyles()
    }
  }

  private updateStyles() {
    if (this.scrolled) {
      // Remove transparent classes and add scrolled classes
      this.headerTarget.classList.remove(...this.headerTransparentClasses)
      this.headerTarget.classList.add(...this.headerScrolledClasses)

      if (this.hasButtonTarget) {
        this.buttonTarget.classList.remove(...this.buttonTransparentClasses)
        this.buttonTarget.classList.add(...this.buttonScrolledClasses)
      }

      if (this.hasNavLinkTarget) {
        this.navLinkTargets.forEach((link) => {
          link.classList.remove(...this.navLinkTransparentClasses)
          link.classList.add(...this.navLinkScrolledClasses)
        })
      }

      if (this.hasMenuButtonTarget) {
        this.menuButtonTarget.classList.remove(
          ...this.menuButtonTransparentClasses,
        )
        this.menuButtonTarget.classList.add(...this.menuButtonScrolledClasses)
      }
    } else {
      // Remove scrolled classes and add transparent classes
      this.headerTarget.classList.remove(...this.headerScrolledClasses)
      this.headerTarget.classList.add(...this.headerTransparentClasses)

      if (this.hasButtonTarget) {
        this.buttonTarget.classList.remove(...this.buttonScrolledClasses)
        this.buttonTarget.classList.add(...this.buttonTransparentClasses)
      }

      if (this.hasNavLinkTarget) {
        this.navLinkTargets.forEach((link) => {
          link.classList.remove(...this.navLinkScrolledClasses)
          link.classList.add(...this.navLinkTransparentClasses)
        })
      }

      if (this.hasMenuButtonTarget) {
        this.menuButtonTarget.classList.remove(
          ...this.menuButtonScrolledClasses,
        )
        this.menuButtonTarget.classList.add(
          ...this.menuButtonTransparentClasses,
        )
      }
    }
  }
}
